export default __webpack_public_path__ + "static/media/menu-watched.229a968d.svg";